var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgObject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_82)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 40.5C14.8807 40.5 11.8892 39.3147 9.68347 37.2049C7.47779 35.0952 6.23865 32.2337 6.23865 29.25C6.23865 26.2663 7.47779 23.4048 9.68347 21.295C11.8892 19.1853 14.8807 18 18 18C18.7367 14.7179 20.8919 11.8337 23.9915 9.98178C27.091 8.12985 30.8811 7.46195 34.5278 8.12499C38.1745 8.78803 41.3792 10.7277 43.4369 13.5173C45.4946 16.3069 46.2367 19.7179 45.5 23H48C50.3207 23 52.5463 23.9219 54.1872 25.5628C55.8281 27.2037 56.75 29.4293 56.75 31.75C56.75 34.0706 55.8281 36.2962 54.1872 37.9372C52.5463 39.5781 50.3207 40.5 48 40.5H18Z",
    stroke: "#0098FF",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 50.5H48",
    stroke: "#0098FF",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_82"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObject);
export default __webpack_public_path__ + "static/media/object.168a1bce50a07fcab9ed9e9e903f1243.svg";
export { ForwardRef as ReactComponent };